import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Service } from '../types/service';
interface ServiceCardProps {
  service: Service;
}
export function ServiceCard({
  service
}: ServiceCardProps) {
  return <article className="group flex h-full flex-col border border-navy-100 bg-white p-7 transition-colors duration-200 ease-out hover:border-navy-300" data-id="element-181" data-mp="2qmb5qf6xc52e">
      <span aria-hidden="true" className="mb-6 block h-px w-10 bg-gold-400" data-id="element-182" data-mp="30hcxzjwhxn97" />
      <h3 className="font-serif text-[21px] leading-snug text-navy-950" data-id="element-183" data-mp="34jhowavk85s5">
        {service.name}
      </h3>
      <p className="mt-4 text-[15px] leading-relaxed text-navy-600" data-id="element-184" data-mp="39a7wlurgkkq0">
        {service.short}
      </p>
      <Link to={service.path} className="mt-auto inline-flex items-center gap-2 pt-7 text-[14px] font-medium text-navy-800 transition-colors duration-150 ease-out hover:text-gold-600" data-id="element-185" data-mp="3ea2jln844q5s">
        Learn More
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-186" data-mp="3o8ic9umsg7he" />
        <span className="sr-only" data-id="element-187" data-mp="1za618wjmi4t4">about {service.name}</span>
      </Link>
    </article>;
}